export const LABELS = {
  MESSAGE_TYPE: "Message Type",
  FEATURE: "Feature",
  ANY: "Any",
  ANY_FEATURE: "Any Feature",
  SEARCH_FEATURE_PLACEHOLDER: "Search features...",
  SEARCH_MESSAGE_PLACEHOLDER: "Search message...",
};

export const MESSAGE_TYPES = {
  CLOUD_INCOMING_CALL: "cloudIncomingCall",
  CLOUD_INCOMING_REQUEST: "cloudIncomingRequest",
  CLOUD_INCOMING_ERROR: "cloudIncomingError",
  CLOUD_OUTGOING_CALL: "cloudOutgoingCall",
  CLOUD_OUTGOING_REQUEST: "cloudOutgoingRequest",
  CLOUD_OUTGOING_ERROR: "cloudOutgoingError",
};

export const MSG_TYPE_MAP = {
  cloudIncomingCall: { source: "Device", msgType: "2" },
  cloudIncomingRequest: { source: "Device", msgType: "3" },
  cloudIncomingError: { source: "Device", msgType: "4" },

  cloudOutgoingCall: { source: "Cloud", msgType: "2" },
  cloudOutgoingRequest: { source: "Cloud", msgType: "3" },
  cloudOutgoingError: { source: "Cloud", msgType: "4" },
};
